<template>
  <layout-content>
    <div class="z-card border-0">
      <user-info class="w-50" />
      <!-- <company-info class="w-50 mt-4" /> -->
      <change-password class="mt-4" />
    </div>
  </layout-content>
</template>

<script>
  import UserInfo from '@core/components/profile/profile-user-info';
  // import CompanyInfo from '@core/components/profile/profile-company-info';
  import ChangePassword from '@core/components/profile/profile-change-password';

  export default {
    components: {
      UserInfo,
      // CompanyInfo,
      ChangePassword
    }
  };
</script>
